
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.75 8.152a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z","stroke":"#56BFC7","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.71 5.186a.5.5 0 00-1 0v4.53L6.164 8.171a.5.5 0 00-.707.707l2.388 2.387c.1.101.233.15.365.147a.499.499 0 00.365-.147l2.388-2.387a.5.5 0 10-.707-.707L8.71 9.717V5.186z","fill":"#56BFC7"}})])
          )
        }
      }
    